import { render, staticRenderFns } from "./IngredientInfo.vue?vue&type=template&id=1452e388&scoped=true&"
import script from "./IngredientInfo.vue?vue&type=script&lang=js&"
export * from "./IngredientInfo.vue?vue&type=script&lang=js&"
import style0 from "./IngredientInfo.vue?vue&type=style&index=0&id=1452e388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452e388",
  null
  
)

export default component.exports